/** Единые ширины CMS-лендинга (согласовано с --app-content-* в globals.css). */

/** Внешний контейнер секции (как Header / Footer / большинство блоков). */
export const LANDING_SECTION_MAX = 1120;

/** Колонка заголовков и текста внутри секции. */
export const LANDING_PROSE_MAX = 720;

/** Горизонтальные отступы контейнера (px-6). */
export const LANDING_SECTION_PAD_X = 24;
